import { render, staticRenderFns } from "./BenefitVisitor.vue?vue&type=template&id=5a1530f9&scoped=true&"
import script from "./BenefitVisitor.vue?vue&type=script&lang=js&"
export * from "./BenefitVisitor.vue?vue&type=script&lang=js&"
import style0 from "./BenefitVisitor.vue?vue&type=style&index=0&id=5a1530f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1530f9",
  null
  
)

export default component.exports